import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EmbedTesterNavbar from '../components/EmbedTesterNavbar';
import EmbedApiKeySection from '../components/EmbedApiKeySection';
import apiService from '../services/api';
import { getPortalPathForUser } from '../utils/portalRouting';
import '../styles/EmbedTesterNavbar.css';

const EmbedTesterPortal = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const currentUser = await apiService.fetchCurrentUser();
        if (cancelled) return;

        if (!currentUser?.is_embed_tester) {
          navigate(getPortalPathForUser(currentUser), { replace: true });
          return;
        }

        setUser(currentUser);
      } catch (error) {
        console.error('Failed to load embed tester portal:', error);
        navigate('/login/', { replace: true });
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  const schoolId = user?.active_school?.id || '';

  if (loading) {
    return (
      <div className="embed-tester-layout">
        <EmbedTesterNavbar />
        <main className="embed-tester-main">
          <p style={{ color: '#64748b' }}>Loading...</p>
        </main>
      </div>
    );
  }

  return (
    <div className="embed-tester-layout">
      <EmbedTesterNavbar />
      <main className="embed-tester-main">
        <h1 className="embed-tester-page-title">Embed API Key</h1>
        <p className="embed-tester-page-subtitle">
          Manage your school embed API key for integration testing. Appearance and other admin settings are not available in this portal.
        </p>
        <EmbedApiKeySection schoolId={schoolId} />
      </main>
    </div>
  );
};

export default EmbedTesterPortal;
